import moment from 'moment';
import { STATES } from 'common/domain/states';
import { MODALS } from 'common/domain/constants';
import {
  REPAYMENT_TYPES,
  AMORTIZATION,
  LOANS_REPAYMENT_SWITCH_CONFIG,
} from 'loans.module/common/domain/constants.loans';

class LoansRepaymentController {
  constructor(
    $stateParams,
    $log,
    loansRepaymentService,
    LoansUserDataService,
    $state,
    $q,
    $window,
    $location
  ) {
    'ngInject';
    this.log = $log;
    this.q = $q;
    this.location = $location;
    this.loan = this.extractLoan($stateParams);
    this.noLoan = this.setErrorWhenNoLoan(this.loan);
    this.loansRepaymentService = loansRepaymentService;
    this.loansUserDataService = LoansUserDataService;
    this.state = $state;
    this.switchOptions = LOANS_REPAYMENT_SWITCH_CONFIG;
    this.isMobileApp = $window.innerWidth < 1024;
    this.showSimulation = false;
    this.loansSimulation = [];
    this.repaymentValue;
  }

  $onInit() {
    this.repaymentType = REPAYMENT_TYPES.SIMULATE;
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp,
    };
  }

  get modal() {
    const modal = $(MODALS.LOANS_REPAYMENT);
    modal.on('hidden.bs.modal', () => this.state.go(STATES.LOANS.MY_LOANS));
    return modal;
  }

  extractLoan(stateParams) {
    return stateParams.loan;
  }

  setErrorWhenNoLoan(loan) {
    return loan === undefined || loan === null;
  }

  isEmpty() {
    return this.noLoan === true;
  }

  onRepaymentType($event) {
    this.showSimulation = false;
    this.location.hash('loans-header');
    this.repaymentType = $event.option;
  }

  onCreateRepayment($event) {
    const repaymentParams = {
      employeeId: this.loansUserDataService._employee.userId,
      loan: this.loan,
      type: this.repaymentType,
      capitalMovementTypeDate: moment().format('YYYY-MM-DD'),
      loanId: this.loan.modalityCode,
      feePeriod: $event
    };

    this.log.debug('onCreateRepayment:', ...repaymentParams);
    if (repaymentParams.type === REPAYMENT_TYPES.TOTAL) {
      this.repaymentTotal(repaymentParams);
    }
    if (repaymentParams.type === REPAYMENT_TYPES.SIMULATE) {
      this.repaymentAmount = $event.repaymentAmount;
      repaymentParams.repaymentAmount = this.repaymentAmount;
      
      this.repaymentSimulate(repaymentParams);
    }
  }

  repaymentTotal(repaymentParams) {
    this.loansRepaymentService
      .createTotalRepayment(repaymentParams)
      .then(
        (response) => {
          this.repaymentAmount = response.data.amount;
          this.repaymentSuccess = true;
          this.repaymentError = false;
        },
        (response) => {
          this.repaymentSuccess = false;
          this.repaymentError = true;
          this.errorMessage = response.data.message;
        }
      )
      .then(() => this.modal.modal('show'));
  }

  repaymentParcial($event) {
    this.feePeriod = $event.feePeriod;
    const repayment = {
      employeeId: this.loansUserDataService._employee.userId,
      loan: this.loan,
      type: this.repaymentType,
      amount: this.repaymentAmount,
      capitalMovementTypeDate: moment().format('YYYY-MM-DD'),
      loanId: this.loan.modalityCode
    };
    this.loansRepaymentService
      .createPartialRepayment(repayment, this.feePeriod)
      .then(
        (response) => {
          this.repaymentAmount = response.data.amount;
          this.showSimulation = false;
          this.repaymentSuccess = true;
          this.repaymentError = false;
        },
        (response) => {
          this.showSimulation = false;
          this.repaymentSuccess = false;
          this.repaymentError = true;
          this.errorMessage = response.data.message;
        }
      )
      .then(() => this.modal.modal('show'));
  }

  repaymentSimulate(repaymentParams) {
    this.loansRepaymentService.simulateRepayment(repaymentParams, AMORTIZATION.FEE).then(
      (response)=> {
        let fee = response.data;
        this.loansRepaymentService.simulateRepayment(repaymentParams, AMORTIZATION.PERIOD).then(
          (response)=> {
            this.loansSimulation = response.data.simulations.concat(fee.simulations);
            this.showSimulation = true;
            this.scrollToResults();
          },
          (error) => {
            this.repaymentError = true;
            this.errorMessage = error.data.message;
          }
        );
      }
    );
  }

  scrollToResults() {
    this.location.hash('option-switch');
  }
}

export default LoansRepaymentController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepayment.controller.js